import { render, staticRenderFns } from "./IntegrationPlaceholderCard.vue?vue&type=template&id=51c60758&scoped=true&"
import script from "./IntegrationPlaceholderCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationPlaceholderCard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationPlaceholderCard.vue?vue&type=style&index=0&id=51c60758&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c60758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
